// removed by extract-text-webpack-plugin
module.exports = {"Burger":"-name__-loca-__3K4F-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.css
// module id = 151
// module chunks = 0